// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CancellationRequestDetail } from './cancellation-request-detail';
import { CancellationRequestDetailStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CancellationRequestDetailStatus extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Enum key */
  id!: CancellationRequestDetailStatusEnum;
  /** Boolean */
  isFinalState!: boolean;
  /** String(50) */
  name!: string;
  /** Inv FK cancellationRequestDetailStatusId */
  cancellationRequestDetails!: CancellationRequestDetail[];
}

